import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import localeEn from '@angular/common/locales/en';
import { StorageService } from './services/storage/storage.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'BigLead.ai';

  constructor(private titleService: Title, private router: Router, private storageService: StorageService){
    this.titleService.setTitle($localize `:@@Title:${this.title}`);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const lang = this.router.url.split('/')[1];
        this.storageService.setItem('lang', lang);
        if (lang === 'fr') {
          registerLocaleData(localeFr);
        } else {
          registerLocaleData(localeEn);
        }
      }
    });
  }
}
